__turbopack_context__.v({
  "show-less": "show-more-rows-module-scss-module__hAT6UG__show-less",
  "show-less-button": "show-more-rows-module-scss-module__hAT6UG__show-less-button",
  "show-more": "show-more-rows-module-scss-module__hAT6UG__show-more",
  "show-more-button": "show-more-rows-module-scss-module__hAT6UG__show-more-button",
  "show-more-content-container": "show-more-rows-module-scss-module__hAT6UG__show-more-content-container",
});
